/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/
/* eslint @typescript-eslint/no-explicit-any: 0 */

import { BaseService } from "@/frameworks/libraries/restservice";

class CommonService extends BaseService {
	constructor() {
		super();
	}

	private async serviceInformationAction() {
		return await this.get<any>("/user/service-info");
	}

	private async geoIPInformationAction() {
		return await this.get<any>("/geoip/info");
	}

	private async networkAuthorizationKeyAction(params: any) {
		return await this.get<any>("/server/accessKey", { params });
	}

	public async serviceInformation() {
		return (await this.serviceInformationAction()).data;
	}

	public async geoIPInformation() {
		return (await this.geoIPInformationAction()).data;
	}

	public async networkAuthorizationKey() {
		const parameter = {
			serverType: "pns"
		};
		return (await this.networkAuthorizationKeyAction(parameter)).data;
	}
}
const CommonAPI = new CommonService();
export default CommonAPI;
